export default __webpack_public_path__ + "static/media/home-shop-classic-02.6b4dc5c3.png";